import axios from 'axios';

import store from '../store';
import { errorResponseAction, successFetchedResultsAction } from '../components/Form/FormContainer/ducks';

import { PoliciesService } from './services/PoliciesService';
import { SERVER_ERROR } from './services/enums/enums';
import { handleIfSuccessResponseHasErrors, getErrorsMessages } from './utils';

const apiPref = process.env.REACT_APP_API_PREF || '';
const API_URL = `${apiPref}/premiumcalculator/v2/calculations/calculate/by-product-type`;

const Api = {
  getPolicies: (requestObject) => axios.post(API_URL, requestObject)
    .then((response) => {
      handleIfSuccessResponseHasErrors(response);

      const resultsArray = PoliciesService.transformResponse(response);
      store.dispatch(successFetchedResultsAction(resultsArray));
    })
    .catch((error) => {
      if (error.response) {
        const errorMessages = getErrorsMessages(error.response);
        store.dispatch(errorResponseAction(errorMessages));
      } else {
        store.dispatch(errorResponseAction(new Array(SERVER_ERROR)));
      }
    }),
};


export default Api;
